import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { updateData } from "../../redux/dataSlice";
import { useEffect, useMemo } from "react";

const getNestedProperty = (data, searchKeys, searchVal) => {
  let keyValArr = [];
  Object.keys(searchKeys).forEach((i) => {
    let keysVal = searchKeys[i].reduce((obj, key) => obj && obj[key], data);
    if (keysVal !== null && keysVal !== undefined) {
      keyValArr.push(keysVal.toString().toLowerCase());
    }
  });
  let checkValues = [];
  keyValArr.forEach((val) => {
    checkValues.push(val.includes(searchVal));
  });
  return checkValues.some((i) => i);
};

const SearchTable = ({ searchCategories, placeholder, width = "w-auto" }) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const isFiltered = useSelector((state) => state.isTableFilter.isFiltered);
  const filteredData = useSelector((state) => state.isTableFilter.filteredData);
  const copyData = useSelector((state) => state.data.copyData);
  let finalData = isFiltered ? filteredData : copyData;
  const searchQuery = searchParams.get("search") || "";

  const searchResult = useMemo(() => {
    let searchVal = searchQuery.trim().toLowerCase();
    if (searchVal.length > 0) {
      const filtered = finalData.filter((item) => {
        return getNestedProperty(item, searchCategories, searchVal);
      });
      return filtered;
    } else {
      return finalData;
    }
  }, [finalData, searchCategories, searchQuery]);

  const handleSearch = (value) => {
    setSearchParams({ search: value });
  };

  useEffect(() => {
    dispatch(updateData(searchResult));
  }, [dispatch, searchResult]);

  return (
    <p className={`relative h-full ${width ?? width}`}>
      <input
        id="search"
        name="search"
        type="text"
        placeholder={placeholder ?? "Search"}
        onChange={(e) => handleSearch(e.target.value)}
        value={searchQuery}
        className="w-full text-dark-blue bg-gray-50 focus-input border-1 border-gray-300 rounded h-9 pl-2 pr-5 placeholder:text-dark-blue placeholder:text-sm placeholder:font-poppins 2xs:max-md:px-1 max-md:h-6 max-lg:h-8 max-md:w-24 max-lg:placeholder:text-[10px] max-lg:text-[10px];"
      />
      <Search
        color="#021472"
        className="absolute right-2 top-[5px] max-md:top-[1px] w-4"
      />
    </p>
  );
};

export default SearchTable;
